import React from 'react';
import { AppRouteProps } from '~/routes';
import Create from './pages/Create';
import Index from './pages/Index';
import Edit from './pages/Edit';

export default function ResourcesFleetInspectionConfigs(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/inspection-config',
      component: Index,
      isProtected: true,
      permissions: ['inspection_config_index'],
    },
    {
      path: '/inspection-config/create',
      component: Create,
      isProtected: true,
      permissions: ['inspection_config_create'],
    },
    {
      path: '/inspection-config/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['inspection_config_edit'],
    },
  ];

  return routes;
}